module.exports = __webpack_public_path__ + "img/footer1.949214f3.webp";